export default {
  setAutoLogout(state) {
    state.didAutoLogout = true;
  },
  setIDToken(state, payload) {
    state.idToken = payload;
  },
  setAccessToken(state, payload) {
    state.accessToken = payload;
  },
  setUserId(state, payload) {
    state.userId = payload;
  },
  signedIn(state) {
    state.isAuthenticated = true;
  },
  logout(state) {
    state.isAuthenticated = false;
  },
  setIsAuthenticated(state, isAuthenticated) {
    state.isAuthenticated = isAuthenticated;
  },
  setEmail(state, payload) {
    state.email = payload;
  },
  setSession(state, payload) {
    state.session = payload;
  },
  setGivenName(state, payload) {
    state.givenName = payload;
  },
  setFamilyName(state, payload) {
    state.familyName = payload;
  },
  setCompanyCode(state, payload) {
    state.companyCode = payload;
  },
  setCompanyName(state, payload) {
    state.companyName = payload;
  },
  setClearAuthData(state) {
    state.cognitoSub = null;
    state.userId = null;
    state.email = null;
    state.idToken = null;
    state.accessToken = null;
    state.refreshToken = null;
    state.didAutoLogout = false;
    state.isAuthenticated = false;
    state.session = null;
    state.givenName = null;
    state.familyName = null;
    state.companyCode = null;
    state.companyName = null;
  },
};
